import { api } from "@/api";
import { invalidateStorageQueries, type StorageBooking } from "./storage";

/** Ends the booking yesterday: entry stops at once, leaving is still allowed. */
export const expireStorageBooking = async (bookingId: string) => {
  const { body } = await api.post<StorageBooking>(
    `/storage/bookings/${bookingId}/expire`,
  );
  invalidateStorageQueries();
  return body;
};
